import React from 'react';
import { Container, ContentText } from './content-result-processing-style';
import { BaSeIcon } from '@base/react';

const ContentResultProcessing = ({moduleId}) => {
  const textStartup =
    'Seu questionário foi enviado e será analisado. Aguarde as novidades sobre sua inscrição em seu e-mail. ';
  const textCommon =
    'Sua entrevista foi enviada e será analisada. Aguarde as novidades sobre sua inscrição em seu e-mail.';

  return (
    <Container>
      <BaSeIcon
        name="system/alarm-line"
        size="32"
        description="icon-times"
        color="#231F20"
      />
      <ContentText>
        <strong>Em processamento</strong>
        <p>{moduleId === 2 ? textStartup : textCommon}</p>
      </ContentText>
    </Container>
  );
};

export default ContentResultProcessing;
